var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.modalId,"size":"lg","title":_vm.title,"hide-header-close":"","ok-only":""}},[_c('ul',_vm._l((_vm.accessOptions),function(option,index){return _c('li',{key:index},[_c('strong',[_vm._v(_vm._s(option.text)+" -")]),_vm._v(" "+_vm._s(option.description)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }